/*  React  */
import React, { useContext, useMemo } from 'react';

const TenantContext = React.createContext({ tenant: null });

export const Tenant = ({ children, data }) => {
    const tenantMemo = useMemo(() => ({ tenant: data }), [data]);

    return (
        <TenantContext.Provider value={tenantMemo}>
            {children}
        </TenantContext.Provider>
    );
};

export const TenantName = () => {
    const { tenant } = useContext(TenantContext);

    if (!tenant) {
        return null;
    }

    return <span>{tenant.name}</span>;
};
